// extracted by mini-css-extract-plugin
export default {"pagination":"Table_pagination__HzjOU","row":"Table_row__pA0Cy","rowSelected":"Table_rowSelected__BYhMS"};